import { render, staticRenderFns } from "./PersonCard.vue?vue&type=template&id=06f40382&scoped=true"
import script from "./PersonCard.vue?vue&type=script&lang=js"
export * from "./PersonCard.vue?vue&type=script&lang=js"
import style0 from "./PersonCard.vue?vue&type=style&index=0&id=06f40382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f40382",
  null
  
)

export default component.exports